/** DEKORK product-card ratings powered by Wise Reviews. */
(function () {
  'use strict';

  var loaded = new WeakSet();

  function number(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function firstNumber(object, keys) {
    if (!object || typeof object !== 'object') return 0;
    for (var i = 0; i < keys.length; i += 1) {
      var n = number(object[keys[i]]);
      if (n > 0) return n;
    }
    return 0;
  }

  function reviewArray(payload) {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== 'object') return [];
    var candidates = [payload.data, payload.reviews, payload.items, payload.results];
    for (var i = 0; i < candidates.length; i += 1) {
      if (Array.isArray(candidates[i])) return candidates[i];
      if (candidates[i] && typeof candidates[i] === 'object') {
        var nested = reviewArray(candidates[i]);
        if (nested.length) return nested;
      }
    }
    return [];
  }

  function productMatches(item, badge) {
    var expectedId = String(badge.dataset.productId || '');
    var expectedHandle = String(badge.dataset.productHandle || '').toLowerCase();
    var ids = [item.product_id, item.productId, item.product && item.product.id].filter(Boolean).map(String);
    var handles = [item.product_handle, item.productHandle, item.product && item.product.handle].filter(Boolean).map(function (v) { return String(v).toLowerCase(); });
    if (ids.length && expectedId) return ids.indexOf(expectedId) !== -1;
    if (handles.length && expectedHandle) return handles.indexOf(expectedHandle) !== -1;
    return true;
  }

  function ratingSummary(payload, badge) {
    var roots = [payload, payload && payload.data, payload && payload.summary, payload && payload.rating_summary];
    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      var average = firstNumber(root, ['average', 'average_rating', 'avg_rating', 'rating_average', 'rating']);
      var count = firstNumber(root, ['count', 'review_count', 'reviews_count', 'total', 'total_reviews']);
      if (average > 0 && count > 0 && average <= 5) return { average: average, count: Math.round(count) };
    }

    var reviews = reviewArray(payload).filter(function (item) {
      return item && productMatches(item, badge) && firstNumber(item, ['rating', 'stars', 'score', 'rating_value']) > 0;
    });
    if (!reviews.length) return null;
    var sum = reviews.reduce(function (total, item) {
      return total + Math.min(5, firstNumber(item, ['rating', 'stars', 'score', 'rating_value']));
    }, 0);
    return { average: sum / reviews.length, count: reviews.length };
  }

  function render(badge, summary) {
    var fill = badge.querySelector('[data-wise-rating-fill]');
    var count = badge.querySelector('[data-wise-rating-count]');
    var average = Math.max(0, Math.min(5, summary.average));
    if (fill) fill.style.width = (average * 20) + '%';
    if (count) count.textContent = '(' + summary.count + ')';
    badge.setAttribute('aria-label', average.toFixed(1) + ' out of 5, ' + summary.count + ' reviews');
    badge.hidden = false;
    badge.classList.add('is-loaded');
  }

  function load(badge) {
    if (!badge || loaded.has(badge)) return;
    loaded.add(badge);

    var productId = badge.dataset.productId;
    var shop = badge.dataset.shop;
    var endpoint = badge.dataset.apiEndpoint;
    if (!productId || !shop || !endpoint) return;

    var url;
    try { url = new URL(endpoint, window.location.origin); } catch (error) { return; }
    url.searchParams.set('itemsPerPage', '1000');
    url.searchParams.set('shop', shop);
    url.searchParams.set('shop_preview', '');
    url.searchParams.set('featured', 'false');
    url.searchParams.set('include_product', 'false');
    url.searchParams.set('product_id', productId);
    url.searchParams.set('productId', productId);
    url.searchParams.set('preview', 'false');
    url.searchParams.set('last_updated_at', window.wiseReviewsLastUpdated || new Date().toISOString());

    var cacheKey = 'dk-wise-rating-v2:' + shop + ':' + productId;
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && cached.payload && Date.now() - cached.time < 900000) {
        var cachedSummary = ratingSummary(cached.payload, badge);
        if (cachedSummary) render(badge, cachedSummary);
      }
    } catch (error) {}

    fetch(url.toString(), { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Wise Reviews API returned ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ time: Date.now(), payload: payload })); } catch (error) {}
        var summary = ratingSummary(payload, badge);
        if (summary) render(badge, summary);
      })
      .catch(function (error) {
        console.warn('[DEKORK] Product rating could not load:', error);
      });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll('[data-wise-rating-badge]');

    // Badges intentionally start with the HTML `hidden` attribute so products
    // without reviews do not leave an empty gap. A hidden element has no layout
    // box, therefore IntersectionObserver will never report it as intersecting.
    // Load immediately; render() removes `hidden` only when a valid rating exists.
    badges.forEach(function (badge) {
      load(badge);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:reorder', function () { init(document); });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-wise-rating-badge]')) load(node);
        init(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
